import React from 'react'
import { styled } from '@mui/system'

const ShopResultImage = styled('img')({
  width: 40,
  height: 40,
})

export function ShopifySearchResult({ hit, components }: { hit: any; components: any }) {
  return (
    <a
      href={`https://shop.premierlacrosseleague.com/products/${hit.handle}`}
      className="aa-ItemLink"
    >
      <div className="aa-ItemContent">
        <ShopResultImage src={hit.image} alt={hit.title} />
        <div className="aa-ItemTitle">
          <components.Highlight hit={hit} attribute="title" />
        </div>
      </div>
    </a>
  )
}
